
// Component Name: Spinner component
// Author: Lavanya S
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date: 29-04-2025
// Description: This is a reusable spinner component for loading indicators.
// Dependencies: React, redux
// Interfaces: Accepts props including selectedFiles, setSelectedFiles,warningToast
// Maintenance History:  1.0 - First Version


import React from "react";
import { ColorRing } from "react-loader-spinner";
import { lkBrandBlue } from "./styleComponents";

const Spinner = () => {
  return (
    <div className="d-flex justify-content-center align-items-center h-100 w-100">
      <ColorRing
        visible={true}
        height="100"
        width="80"
        ariaLabel="color-ring-loading"
        wrapperStyle={{}}
        wrapperClass="color-ring-wrapper"
        colors={[lkBrandBlue, lkBrandBlue, lkBrandBlue, lkBrandBlue, lkBrandBlue]}
      />
    </div>
  );
};

export default Spinner;
